import { useSelector } from "react-redux";
import { readCachedEntitlement } from "./coldStart";
import { userAccess } from "./userAccessPort";
/**
 * Entitlements: what a user *has*, as opposed to what a user *may do*.
 *
 * Feature access (see featureCatalog / useFeatureAccess) answers "am I allowed
 * to run this action, and what does it cost". Entitlements answer "what does
 * this account include". Ads are the latter — nothing is denied, there is no
 * balance, and no call is metered.
 *
 * Ad-free is subscription-only and stays that way; credits never buy it.
 */
/**
 * Single source of truth for ad-free. Deliberately named after the entitlement
 * ("this account is ad-free") rather than the billing state ("this user paid")
 * or the UI decision ("show ads"), so the backend can own it later by adding an
 * `adFree` flag to the profile payload — only this function body changes.
 *
 * The cached read covers the window between page load and the first
 * users/profile response; without it a returning subscriber briefly renders
 * empty ad slots. It must be read per call, not once at module load, so it
 * follows the cache being cleared on logout.
 */
export const adFreeSelector = (state) => userAccess.paid(state) || readCachedEntitlement().paid;
export const useAdFree = () => useSelector(adFreeSelector);
export const useShowAds = () => !useSelector(adFreeSelector);
//# sourceMappingURL=entitlements.js.map